import { motion } from 'framer-motion'

const skus = [
  {
    name: 'ENDOPATH XCEL Dilating Tip Trocar (11mm)',
    units: '18 units on hand. Par: 50. Short by 32 units.',
    note: '4 laparoscopic procedures scheduled Tuesday AM.',
    priority: 'HIGH',
    sku: 'D11LT',
    gtin: '20705036001567',
  },
  {
    name: 'ENDOPATH BASX Bladeless Trocar (11mm)',
    units: '9 units on hand. Par: 20. Short by 11 units.',
    note: 'Secondary Trocar item for same laparoscopic case load.',
    priority: 'HIGH',
    sku: 'TB11LT',
    gtin: '20705036002991',
  },
  {
    name: 'ENDOPATH Clip Applier MCS20 (single-use, 24/box)',
    units: '14 units on hand. Par: 24. Short by 10 units.',
    note: 'Order within 48 hours.',
    priority: 'LOW',
    sku: 'CK094',
    gtin: 'N/A',
  },
  {
    name: 'ENDOPATH DEXTRUS Med Access Retractor',
    units: '11 units on hand. Par: 13. Short by 2 units.',
    note: 'Consumption up 34% vs. prior 30 days (cause unconfirmed). Confirm with OR nurse manager before adjusting par.',
    priority: 'LOW',
    sku: 'FLR02',
    gtin: '20705036001970',
  },
]

export default function DemandSensingPanel({ onClose, onChatWithAgent }) {
  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, layout: { duration: 0.45, ease: [0.16, 1, 0.3, 1] } }}
      style={{
        width: 'clamp(300px, 25%, 420px)',
        height: '100%',
        flexShrink: 0,
        background: 'rgba(0,0,0,0.3)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div style={{
        padding: '18px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
      }}>
        <span style={labelStyle}>Demand Sensing Report</span>
        <motion.button
          whileHover={{ scale: 1.15, background: 'rgba(255,255,255,0.12)' }}
          whileTap={{ scale: 0.9 }}
          onClick={onClose}
          style={{
            width: 24, height: 24, borderRadius: 6,
            background: 'transparent', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#A39992', fontSize: 14, fontFamily: 'inherit',
          }}
        >
          ✕
        </motion.button>
      </div>

      {/* Scrollable body */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px 20px' }} className="feed-scroll">

        {/* Title block */}
        <div style={{ marginBottom: 24 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.2, marginBottom: 6 }}>
            4 SKUs flagged for 9/1 OR schedule
          </h2>
          <p style={{ fontSize: 11, color: '#A39992', lineHeight: 1.5 }}>
            J&J Demand Sensing Agent · Mercy General Inventory Agent
          </p>
          <p style={{ fontSize: 11, color: '#A39992' }}>08/02/26, 11:53 PM</p>
        </div>

        {/* Summary */}
        <div style={{ marginBottom: 28 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: '#FFFFFF', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Summary
          </p>
          <p style={{ fontSize: 12, color: '#D5CFC9', lineHeight: 1.6 }}>
            Overnight analysis flagged 4 products below par threshold ahead of a high-volume OR week. Two Trocar items require priority attention before Tuesday's laparoscopic cases. One Retractor item shows a consumption anomaly that may warrant a conversation with the OR nurse manager before you adjust par. One Clip Applier is approaching threshold on a slower timeline.
          </p>
        </div>

        {/* SKUs */}
        <div>
          <p style={{ fontSize: 11, fontWeight: 700, color: '#FFFFFF', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            SKUs
          </p>
          {/* scroll fade wrapper */}
          <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {skus.map((sku, i) => (
                <SkuCard key={i} sku={sku} index={i} />
              ))}
            </div>
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, height: 40,
              background: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.35))',
              pointerEvents: 'none', borderRadius: '0 0 4px 4px',
            }} />
          </div>
        </div>
      </div>

      {/* Footer actions */}
      <div style={{
        padding: '16px 20px',
        display: 'flex',
        gap: 8,
        flexShrink: 0,
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}>
        <motion.button
          whileHover={{ background: 'rgba(255,255,255,0.12)' }}
          whileTap={{ scale: 0.97 }}
          onClick={onChatWithAgent}
          style={{
            flex: 1, height: 36, borderRadius: 8,
            background: 'rgba(255,255,255,0.07)', border: 'none',
            color: '#FFFFFF', fontSize: 12, fontWeight: 500,
            cursor: 'pointer', fontFamily: 'inherit',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          }}
        >
          <BoltIcon /> Chat with agent
        </motion.button>
        <motion.button
          whileHover="hover"
          initial="rest"
          whileTap={{ scale: 0.97 }}
          variants={{ rest: {}, hover: { filter: 'brightness(1.1)' } }}
          style={{
            flex: 1, height: 36, borderRadius: 8,
            background: '#EB1700', border: 'none',
            color: '#FFFFFF', fontSize: 12, fontWeight: 500,
            cursor: 'pointer', fontFamily: 'inherit',
            position: 'relative', overflow: 'hidden',
          }}
        >
          <motion.span
            variants={{
              rest: { x: '-110%' },
              hover: { x: '210%' },
            }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
            style={{
              position: 'absolute', inset: 0, width: '60%',
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
              pointerEvents: 'none', skewX: '-12deg',
            }}
          />
          + Add all to order
        </motion.button>
      </div>
    </motion.div>
  )
}

function SkuCard({ sku, index }) {
  const isHigh = sku.priority === 'HIGH'

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1], delay: 0.1 + index * 0.07 }}
      style={{
        background: 'rgba(0,0,0,0.25)',
        borderRadius: 4,
        padding: '12px 14px',
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.4, flex: 1 }}>
          {sku.name}
        </span>
        <motion.button
          whileHover={{ scale: 1.1, filter: 'brightness(1.2)' }}
          whileTap={{ scale: 0.92 }}
          style={{
            width: 22, height: 22, borderRadius: 6,
            background: '#EB1700', border: 'none',
            color: '#FFFFFF', fontSize: 14, fontWeight: 700,
            cursor: 'pointer', flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          +
        </motion.button>
      </div>

      <span style={{ fontSize: 12, color: '#D5CFC9', lineHeight: 1.4 }}>{sku.units}</span>
      <span style={{ fontSize: 11, color: '#A39992', fontStyle: 'italic', lineHeight: 1.4 }}>{sku.note}</span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2, flexWrap: 'wrap' }}>
        <motion.span
          animate={isHigh ? { boxShadow: ['0 0 0 0px rgba(235,23,0,0)', '0 0 0 3px rgba(235,23,0,0.25)', '0 0 0 0px rgba(235,23,0,0)'] } : {}}
          transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut', delay: 0.8 }}
          style={{
            fontSize: 9, fontWeight: 700,
            color: isHigh ? '#FF6B6B' : '#D4A843',
            background: isHigh ? 'rgba(235,23,0,0.2)' : 'rgba(212,168,67,0.2)',
            borderRadius: 3, padding: '2px 6px',
            textTransform: 'uppercase', letterSpacing: '0.06em',
          }}
        >
          {sku.priority}
        </motion.span>
        <span style={metaBadge}>SKU {sku.sku}</span>
        <span style={metaBadge}>GTIN {sku.gtin}</span>
        <motion.button
          whileHover={{ scale: 1.15 }}
          style={{
            marginLeft: 'auto', background: 'transparent', border: 'none',
            cursor: 'pointer', color: '#A39992', padding: 2,
            display: 'flex', alignItems: 'center',
          }}
        >
          <SendIcon />
        </motion.button>
      </div>
    </motion.div>
  )
}

function BoltIcon() {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none">
      <path d="M6 1L1 7h4l-1 4 5-6H5l1-4z" fill="currentColor" />
    </svg>
  )
}

function SendIcon() {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none">
      <path d="M6 1L1 7h4l-1 4 5-6H5l1-4z" fill="#A39992" />
    </svg>
  )
}

const labelStyle = {
  fontSize: 10, fontWeight: 700,
  color: '#A39992', textTransform: 'uppercase', letterSpacing: '0.09em',
}

const metaBadge = {
  fontSize: 9, fontWeight: 600,
  color: '#A39992',
  background: 'rgba(255,255,255,0.07)',
  borderRadius: 3, padding: '2px 6px',
  letterSpacing: '0.04em',
}
